module.exports = __webpack_public_path__ + "static/media/img_noble.cd8bd4e4.jpg";